/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, Select, Text, TextInput } from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { useEffect, useState } from "react";
import {
  CreateTemplateSubsectionInput,
  CreateTemplateSubsectionMutation,
  CreateTemplateSubsectionMutationVariables
} from "../../../API";
import { createTemplateSubsection } from "../../../graphql/mutations";
const client = generateClient();

type addNewSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  fetchTemplate: (templateId: string) => void;
};

const AddSubSectionTemplateModal = (props: addNewSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [subsectionName, setSubsectionName] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter(
        (section: any) =>
          section.isSimple === false || section.isSimple === null
      )
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });
    if (initSections && initSections.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template]);

  const handleAddSubSection = async () => {
    if (subsectionName?.trim() == "" || sectionId == "") {
      setErrorMsg("Please provide both subsection name and section");
      return;
    }
    setErrorMsg("");
    setIsLoading(true);
    try {
      const createSubsectionInput: CreateTemplateSubsectionInput = {
        name: subsectionName,
        sID: sectionId,
        tID: template.id,
        fieldOrder: []
      };
      const createSubsectionVars: CreateTemplateSubsectionMutationVariables = {
        input: createSubsectionInput
      };

      const createSubsectionResult = await client.graphql<
        GraphQLQuery<CreateTemplateSubsectionMutation>
      >({ query: createTemplateSubsection, variables: createSubsectionVars });
      console.log(createSubsectionResult);
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error creating sub section:", err);
      setIsLoading(false);
    }
  };
  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
    setSubsectionName("");
  };
  return (
    <Modal
      opened={modalOpened}
      onClose={closeAndResetModal}
      title="Add subsection"
    >
      <TextInput
        label="Name"
        placeholder="Enter template subsection"
        value={subsectionName}
        onChange={(event) => setSubsectionName(event.target.value)}
        required
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Select
        placeholder="Select section"
        label="Section"
        data={sections}
        value={sectionId}
        onChange={(_value, option) => setSectionId(option.value)}
      />

      <Group mt="md">
        <Group mt="md">
          <Button loading={isLoading} onClick={handleAddSubSection}>
            Save
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default AddSubSectionTemplateModal;
